import { createModal } from "Components/Modal/helpers/createModal";
import { SchedulePhaseModalItem } from "../SchedulePhaseHelper";

export const useSchedulePhaseModal = createModal<SchedulePhaseModalItem>({});
